export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, "");
  }

  const hostname = window.location.hostname;
  
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:8091";
  } else if (hostname === "toxbox-dev.provaantech.com") {
    return "https://dev.toxboxai.com";
  } else if (hostname === "toxboxai.com" || hostname === "www.toxboxai.com") {
    return "https://prod.toxboxai.com";
  }
  
  return "https://dev.toxboxai.com"; // Fallback
};

export const API_BASE_URL = getApiBaseUrl();